import CheckboxGroup from "@/components/CheckboxGroup";
import { renderCabinsColor } from "@/utils/commonRender";

import { useFilterContext } from "../FilterContext";

const FilterItemBanks = () => {
  const { filterData, setFilterData, filterOptions } = useFilterContext();
  return (
    <CheckboxGroup
      options={filterOptions.cabinsOptions.map((item) => {
        return {
          ...item,
          label: renderCabinsColor(item.label, `Must have ${item.label}`),
        };
      })}
      value={filterData.cabins.length > 0 ? filterData.cabins : []}
      onChange={(value) => {
        setFilterData({
          cabins: value,
        });
      }}
    />
  );
};

export default FilterItemBanks;
